import { useQuery } from '@tanstack/react-query';

import { getVipTrialReferrerApi } from '@flipster/apis/v1/user';

import { useAuth } from '../shared/auth/state';

export function useVipTrialReferrer() {
  const { isCookieLoggedIn } = useAuth();

  const { isPending, data } = useQuery({
    queryKey: ['getVipTrialReferrerApi', isCookieLoggedIn],
    queryFn: getVipTrialReferrerApi,
    select: (res) => res.data,
    enabled: isCookieLoggedIn,
  });

  return { isLoading: isPending, data };
}
